module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-5662659c!./packages/dof-checkbox/diablo.css
// module id = 477
// module chunks = 0 1